export default "/images/ef012373b5396f7e4b5c92dfda3c4670.avif";